import styled from "styled-components";
import background from "../../Assets/background.jpeg"

export const CardDiv = styled.div`
    width: 60%;
    height: 200px;
    display: flex;
    background-image: url(${background});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    justify-content: space-between;
    padding: 0 100px;
    position: relative;
    right: -100px;

    section{
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: var(--primary-color);
        right: 0;
        opacity: 0.6;
    }

    h1{
        font-size: 42px;
        z-index: 2;
    }

    h2{
        text-align: center;
        z-index: 2;
        
    }

    >div{
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
    }

    img{
        width: 200px;
        position: absolute;
        right: 10px;
        bottom: 0px;
    }

    span{
        font-size: 24px;
        color: var(--white-color);
        z-index: 2;
        font-weight: 600;
    }

    button{
        z-index: 2;
        background-color: var(--secundary-color);
        border: none;
        height: 40px;
        width: 150px;
        color: black;
        font-weight: 700;
        font-size: 16px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    
    button:hover{
        bottom: 1px;
    }

    @media (max-width: 1250px){
        width: 55%;

        >div{
            width: 100%;
            align-items: center;
        }

        img{
            display: none;
        }
    }

    @media (max-width: 1024px){
        width: 90%;
        right: 0;
    }

    @media (max-width: 600px){
        width: 90%;
        right: 0;
        padding: 0 40px;

        h1{
            font-size: 28px;
        }

        span{
            font-size: 18px;
        }
    }
`